import React from 'react'
import { Stack, Portal } from '@mui/material'

import Snackbar from 'src/components/snackbar/Snackbar'
import { SnackbarSettings } from 'src/components/snackbar/types'
import SnackbarContext from 'src/components/snackbar/internals/SnackbarContext'

interface SnackbarContainerProps {
  snackbars?: SnackbarSettings[]
}

const SnackbarContainer: React.FC<SnackbarContainerProps> = ({ snackbars }) => {
  const { removeSnackbar } = React.useContext(SnackbarContext)

  return (
    <Portal>
      <Stack spacing={2} sx={{ width: '100%', position: 'fixed', bottom: 0, left: 0, right: 0 }}>
        {snackbars?.map(({ id, message, onRemove: _onRemove, status, severity, ...rest }) => {
          return (
            <Snackbar
              key={id}
              id={id}
              message={message}
              severity={severity || status}
              onRemove={() => {
                removeSnackbar(id)
                _onRemove?.()
              }}
              {...rest}
            />
          )
        })}
      </Stack>
    </Portal>
  )
}

export default SnackbarContainer
